import Vue from 'vue';
import moment from 'moment-jalaali';

export default () => {
  Vue.filter('weekdayPersian', function (value) {
    switch (value) {
      case 0:
        return 'شنبه';
      case 1:
        return 'یکشنبه';
      case 2:
        return 'دوشنبه';
      case 3:
        return 'سه شنبه';
      case 4:
        return 'چهار شنبه';
      case 5:
        return 'پنجشنبه';
      case 6:
        return 'جمعه';
      default:
        break;
    }
  });

  Vue.filter('monthJalali', function (value) {
    switch (value) {
      case 1:
        return 'فروردین';
      case 2:
        return 'اردیبهشت';
      case 3:
        return 'خرداد';
      case 4:
        return 'تیر';
      case 5:
        return 'مرداد';
      case 6:
        return 'شهریور';
      case 7:
        return 'مهر';
      case 8:
        return 'آبان';
      case 9:
        return 'آذر';
      case 10:
        return 'دی';
      case 11:
        return 'بهمن';
      case 12:
        return 'اسفند';
      default:
        break;
    }
  });

  // EXAMPLE input '20124.054874' output should be something like this 20,124.054
  Vue.filter('formatPrice', (value) => {
    const price = parseFloat(value).toFixed(3);
    const result = price.toString();
    return parseFloat(result).toLocaleString();
  });

  Vue.filter('minToIso', (value) => {
    let hour = parseInt(parseInt(value) / 60);
    let min = parseInt(value) % 60;
    if (min < 10) {
      min = min + '0';
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    return `${hour}:${min}`;
  });

  Vue.filter('IsoToMin', (value, time) => {
    const date = value.slice(0, -3);
    const splitDate = date.split(':');
    const resultMin =
      parseInt(splitDate[0] * 60) + parseInt(splitDate[1]) + time;
    return resultMin;
  });

  Vue.filter('faToEn', (value) => {
    const fa = [...'۰۱۲۳۴۵۶۷۸۹'];
    const en = [...'0123456789'];
    const faToEn = s =>
      s.replace(new RegExp(`[${fa.join('')}]`, 'g'), m => en[fa.indexOf(m)]);

    return faToEn(value)
  });

  Vue.filter('mildaiToJalali', (value) => {
    return moment(value).locale('fa').format('jYYYY/jMM/jDD');
  });
};
